import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_digitize-pro-2/artifacts/bzn1ek7z_image.png";

const LogoSplash = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Lock body scroll while intro plays
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // Total on-screen time: 2600ms (entrance + hold + fade)
    const t = setTimeout(() => setVisible(false), 2600);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    if (!visible) {
      // Restore scroll immediately on fade-out
      document.body.style.overflow = '';
    }
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#050914] overflow-hidden"
          aria-hidden={!visible}
          data-testid="logo-splash"
        >
          {/* Ambient */}
          <div className="absolute inset-0 hero-mesh" />
          <div className="absolute inset-0 noise-overlay" />
          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage:
                'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
              backgroundSize: '80px 80px',
            }}
          />
          <motion.div
            className="absolute w-[900px] h-[900px] rounded-full bg-gradient-to-br from-[#FF6B35]/8 via-blue-600/6 to-transparent blur-3xl"
            animate={{ scale: [1, 1.08, 1], opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.94, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="relative z-10 flex flex-col items-center px-6"
          >
            <img
              src={LOGO_URL}
              alt="Digitize Intl."
              className="w-[80vw] max-w-[900px] h-auto object-contain brightness-0 invert"
              data-testid="logo-splash-image"
            />
            <motion.p
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.7 }}
              className="mt-8 text-[11px] md:text-xs tracking-[0.35em] uppercase text-white/40 font-bold text-center"
            >
              Premium digital solutions · Est. 2026
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LogoSplash;
